module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_4-ccf923647f68bf82e82d45ab9265550e.png";